import { Injectable } from '@angular/core';


type StorageTypes = 'localstorage' | 'sessionstorage';


@Injectable()
export class RenderStorageService {

  public insert(id: string, value: string, type: StorageTypes = 'localstorage'): boolean {
    if (!id || !value) {
      return false;
    }
    if (type === 'localstorage') {
      localStorage.setItem(id, value);
    } else {
      sessionStorage.setItem(id, value);
    }
    return true;
  }

  public update(id: string, value: string, type: StorageTypes = 'localstorage'): boolean {
    let hasInserted: boolean = false;
    if (id && value && this.exists(id, type)) {
      hasInserted = this.insert(id, value, type);
    }
    return hasInserted;
  }

  public exists(id: string, type: StorageTypes = 'localstorage'): boolean | string {
    if (type === 'localstorage') {
      return id && localStorage.getItem(id) !== null;
    }

    return id && sessionStorage.getItem(id) !== null;
  }

  public remove(id: string, type: StorageTypes = 'localstorage'): boolean {
    if (!id) {
      return false;
    }
    if (type === 'localstorage') {
      localStorage.removeItem(id);
    } else {
      sessionStorage.removeItem(id);
    }
    return true;
  }

  public removeAll(type: StorageTypes = 'localstorage'): void {
    if (type === 'localstorage') {
      localStorage.clear();
    } else {
      sessionStorage.clear();
    }
  }

  public getItem(id: string, type: StorageTypes = 'localstorage'): string | null {
    if (type === 'localstorage') {
      return localStorage.getItem(id);
    }

    return sessionStorage.getItem(id);
  }

}
